var React = require('react');

function SprayCan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288 32a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM384 32a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm0-32a32 32 0 1 0-32-32 32 32 0 0 0 32 32zM160 256a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 160H96a96 96 0 0 0-96 96v224a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V256a96 96 0 0 0-96-96zm-64 256a80 80 0 1 1 80-80 80 80 0 0 1-80 80zm64-384a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v96h128z","className":"fa-primary","key":2})]);
}

SprayCan.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = SprayCan;

SprayCan.default = SprayCan;
